const common = {

}

/**
 * 多选筛选
 * filterArr:精灵数组/持有物数组
 * filterCon:筛选条件数组
 * 
 */
common.muliFilter = function(filterArr,filterCon){
    if(!filterArr || !filterCon){
        return false
    }else{
        if(filterCon.length == 0){
            return filterArr
        }else {
            let resultArr = []
            filterCon.forEach(item => {
                filterArr.forEach(itemC => {
                    if(itemC['sort'] == item){
                        resultArr.push(itemC)
                    }
                })
            })
            return resultArr
        }
    }
}

/**
 * 多选删除
 * filterArr:精灵数组
 * filterCon:筛选条件数组
 * 
 */

common.muliDelFilter = function(filterArr,filterCon){
    if(!filterArr || !filterCon){
        return false
    }else{
        if(filterCon.length == 0){
            return filterArr
        }else{
            let resultArr = []
            filterArr.forEach(item => {
                let result = true
                filterCon.forEach(itemC => {
                    if(itemC == item['name']){
                        result = false
                    }
                })
                if(result){
                    resultArr.push(item)
                }
            })
            return resultArr
        }
    }
}

/**
 * 单人随机精灵技能
 * filterArr:精灵技能数组
 * filterCon:精灵信息(object)
 */
common.signleRandomSkill = function (filterArr, filterCon) {
    if(!filterArr || !filterCon){
        return false
    }else{
        let resultArr = []
        let resultObj = {}
        filterArr.forEach(item => {
            
            if (item['name'] == filterCon['name']) {
                resultObj = item
            }
        })
        let number1 = resultObj['skillGroup1'].length
        let obj1 = resultObj['skillGroup1'][Math.floor(Math.random() * number1)]
        obj1['name'] = resultObj['name']
        let number2 = resultObj['skillGroup2'].length
        let obj2 = resultObj['skillGroup2'][Math.floor(Math.random() * number2)]
        obj2['name'] = resultObj['name']
        resultArr.push(obj1)
        resultArr.push(obj2)
        return resultArr
    }
}

/**
 * 单选随机对战道具
 * filterArr:对战道具数组
 */
common.signleBattleItem = function(filterArr){
   
    if(!filterArr){
        return false
    }else{
        let len = filterArr.length
        return  filterArr[Math.floor(Math.random() * len)]
    }
}


/**
 * 多人随机精灵,随机出两边精灵，并将技能组加入数组中
 * _pokenmonArr:能选择精灵数组
 * skillArr:所有技能数组
 * isRepeatPokemon:是否允许重复精灵
 * randomPerson:每组随机玩家
 */

common.muliRandomPokemon = function(_pokenmonArr,skillArr,isRepeatPokemon,randomPerson){
    if(!_pokenmonArr || !skillArr){
        return false
    }else{
        let pokenmonArr = JSON.parse(JSON.stringify(_pokenmonArr))
        let finalObj= {}
        let leftArr = []
        let rightArr = []
        pokenmonArr.forEach((item,index) => {
            skillArr.forEach(itemC => {
                if(item['name'] == itemC['name']){
                    pokenmonArr[index]['skillGroup1'] = itemC['skillGroup1']
                    pokenmonArr[index]['skillGroup2'] = itemC['skillGroup2']
                }
            })
        })
        // 是否允许重复精灵
        let leftPokemon = JSON.parse(JSON.stringify(pokenmonArr))
        let rightPokemon = JSON.parse(JSON.stringify(pokenmonArr))
        if(isRepeatPokemon){
            for(let x = 0;x < randomPerson;x++){
                let _leftIndex = Math.floor(Math.random() * leftPokemon.length)
                leftArr.push(leftPokemon[_leftIndex])
                leftPokemon.splice(_leftIndex,1)
                let _rightIndex = Math.floor(Math.random() * rightPokemon.length)
                rightArr.push(rightPokemon[_rightIndex])
                rightPokemon.splice(_rightIndex,1)
            }
        }else{
            for(let x = 0;x < randomPerson * 2;x++){
                if(x < randomPerson){
                    let _leftIndex = Math.floor(Math.random() * pokenmonArr.length)
                    leftArr.push(pokenmonArr[_leftIndex])
                    pokenmonArr.splice(_leftIndex,1)
                }else{
                    let _rightIndex = Math.floor(Math.random() * pokenmonArr.length)
                    rightArr.push(pokenmonArr[_rightIndex])
                    pokenmonArr.splice(_rightIndex,1)
                }
            }
        }
        finalObj['left'] = leftArr
        finalObj['right'] = rightArr
        return finalObj
    }
}

/**
 * 多人随机精灵，随机出两边精灵技能，并返回
 * _pokemonArr:两侧的精灵数组
 * skillArr:所有技能数组
 */
common.muliRandomSkill = function(_pokemonArr,skillArr){
    if(!_pokemonArr || !skillArr){
        return false
    }else{
        let pokemonArr = JSON.parse(JSON.stringify(_pokemonArr))
        // 技能
        pokemonArr.forEach((item,index) => {
            skillArr.forEach(itemC => {
                if(item['name'] == itemC['name']){
                    let number1 = itemC['skillGroup1'].length
                    let obj1 = itemC['skillGroup1'][Math.floor(Math.random() * number1)]
                    pokemonArr[index]['skill1'] = obj1
                    let number2 = itemC['skillGroup2'].length
                    let obj2 = itemC['skillGroup2'][Math.floor(Math.random() * number2)]
                    pokemonArr[index]['skill2'] = obj2
                }
            })
        })
        return pokemonArr
    }
}

/**
 * 多人随机精灵，随机姓名赋值
 * _leftArr:左侧数组
 * _rightArr:右侧数组
 * _nameArr:姓名数组
 */
common.muliName = function(_leftArr,_rightArr,_nameArr){
    if(!_leftArr || !_rightArr || !_nameArr){
        return false
    }else{
        let leftArr = JSON.parse(JSON.stringify(_leftArr))
        let rightArr = JSON.parse(JSON.stringify(_rightArr))
        let nameArr = JSON.parse(JSON.stringify(_nameArr))
        leftArr.forEach((item,index) => {
            if(nameArr[0]){
                leftArr[index]['realName'] = nameArr[0]
                nameArr.splice(0,1)
            }else{
                item['realName'] = ''
            }
        })
        rightArr.forEach((item,index) => {
            if(nameArr[0]){
                rightArr[index]['realName'] = nameArr[0]
                nameArr.splice(0,1)
            }else{
                item['realName'] = ''
            }
        })
        return {
            "left":leftArr,
            "right":rightArr
        }
    }
}
export default common


// WEBPACK FOOTER //
// ./src/utils/fn.js